import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import NewFilterSelect from './NewFilterSelect';

export const DateViewOptions = {
  DAY: {
    label: 'Day',
    value: 'day',
  },
  WEEK: {
    label: 'Week',
    value: 'week',
  },
  MONTH: {
    label: 'Month',
    value: 'month',
  },
  * [Symbol.iterator]() {
    yield DateViewOptions.DAY;
    yield DateViewOptions.WEEK;
    yield DateViewOptions.MONTH;
  },
};

export default function DateViewFilter({
  initialValue, onChange, disable,
}) {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    if (value) {
      onChange(value);
    }
  }, [value]);

  return (
    <NewFilterSelect
      label="Date View:"
      onChange={option => setValue(option)}
      name="dateViewOption"
      options={[...DateViewOptions]}
      selected={value}
      disable={disable}
    />
  );
}

DateViewFilter.defaultProps = {
  initialValue: DateViewOptions.DAY,
  disable: false,
};

DateViewFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  initialValue: PropTypes.oneOf([...DateViewOptions]),
  disable: PropTypes.bool,
};
